'use strict';

var subElementCtrl = [function() {
    var _this = this;
    this.config = false;
    this.elementToggle = true;

    this.toggleConfig = function() {
        this.config = !this.config;
    };
    this.toggleSection = function() {
        this.elementToggle = !this.elementToggle;
    }    

    this.removeSubElement = function(id) {
        this.removeElement({
            id: id
        });
    };

    this.cloneSubElement = function(id) {
        this.cloneElement({
            id: id
        });
    };

    this.getBorderBottomStyle = function() {
        let styles = {};
        if (_this.isAdmin) styles['padding-bottom'] = '0px';
        if ((_this.element.type == 'group' || _this.element.type == 'simplelist') && !_this.elementToggle) {
            styles['border-bottom'] = '2px solid #dddddd';
        }
        return styles;
    };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            removeElement: '&',
            cloneElement: '&',
            form: '=',
            subnodos: '=',
            reportConfig:"=",
            isForValidator: '=',
            pageIndex: '=',
            elementIndex: '=',
            subElementIndex: '=',
            subElement2Index: '=',
            isAdmin: '=',
        },
        replace: true,
        controller: subElementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/subElement2Directive.html'
    };
};
